import MyAccountContainerBody from '@/components/layout/MyAccountContainerBody';
import { useStore } from '@/hooks/useStore';
import { isPathEk } from '@/utils/routes';
import { isAdminOrOwner } from '@/utils/utils';
import { observer } from 'mobx-react-lite';
import { ReactNode, useEffect, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import AdminPanelLayout from './AdminPanelLayout';
import ScrollToTop from '@/components/general/ScrollToTop';
import { ROUTES } from '@/configs/constants';

export default observer(function MyAccountPanelLayout({ children }: { children?: ReactNode }) {
    // hooks
    const { pathname } = useLocation();
    const isEk = isPathEk(pathname);
    const isPathBikeReturnPAth = pathname.includes(ROUTES.bikeReturn.href);

    // store
    const {
        authStore: {
            profileGas,
            profileEk,
            getProfile
        }
    } = useStore();

    // lifecycle
    useEffect(() => {
        getProfile();
    }, [pathname]);

    // function
    // Check is on view-all page mobile of topservice section

    const checkAdminOwner = useMemo((): boolean | undefined => {
        const profile = isEk ? profileEk : profileGas;
        const convertRoleIdNumber = !profile?.roleId ? NaN : Number(profile?.roleId);

        if (isNaN(convertRoleIdNumber)) {
            return undefined;
        }
        return isAdminOrOwner(convertRoleIdNumber);
    }, [profileGas?.roleId, profileEk?.roleId, isEk]);

    const content = useMemo(() => {
        if (isPathBikeReturnPAth) {
            return (
                <>
                    <MyAccountContainerBody
                        showHeader={true}
                        showFooter={false}
                        showFooterMenu={true}
                    >
                        {children ?? <Outlet />}
                    </MyAccountContainerBody>

                    <ScrollToTop />
                </>
            );
        }
        if (checkAdminOwner) {
            return (
                <AdminPanelLayout showCenter={true}>
                    {children ?? <Outlet />}
                </AdminPanelLayout>
            );
        } else if (checkAdminOwner === false) {
            return (
                <>
                    <MyAccountContainerBody
                        showHeader={true}
                        showFooter={false}
                        showFooterMenu={true}
                    >
                        {children ?? <Outlet />}
                    </MyAccountContainerBody>

                    <ScrollToTop />
                </>
            );
        }
        return <div className='h-[100vh]'></div>;
    }, [checkAdminOwner, children]);

    return <>{content}</>;

    // const checkAdminOwner = useMemo((): boolean => {
    //     if (isEk) {
    //         return !profileEk?.roleId ? false : isAdminOrOwner(Number(profileEk?.roleId));
    //     }
    //     return !profileGas?.roleId ? false : isAdminOrOwner(Number(profileGas?.roleId));
    // }, [profileGas?.roleId, profileEk?.roleId]);

    // return (
    //     <>
    //         {checkAdminOwner ?
    //             (
    //                 <AdminPanelLayout>
    //                     {children ?? <Outlet />}
    //                 </AdminPanelLayout>
    //             ) :
    //             (

    //                 <>
    //                     <MyAccountContainerBody
    //                         showHeader={showHeader}
    //                         showFooter={showFooter}
    //                         showFooterMenu={true}
    //                     >
    //                         {children ?? <Outlet />}
    //                     </MyAccountContainerBody>

    //                     <ScrollToTop />
    //                 </>

    //             )}
    //     </>
    // );
});
